import book from "./figma/book.png";
import paperShelf from "./figma/paper-shelf.png";
import tutorcloudLogoMark from "./figma/tutorcloud-logo-mark.png";
import temaLogo from "./figma/Logo.png";
import slideDeckBrandLogo from "./figma/slide-deck-brand-lockup.png";
import unlockLocksmith from "./figma/unlock-locksmith.svg";
import avatar from "./figma/avatar.jpg";
import heroMain from "./figma/hero-main.png";
import heroDashboardIllustration from "./figma/hero-dashboard-illustration.png";
import heroImage from "./figma/heroimage.png";
import teachThisTopicImage from "./figma/teachthetopicimage.png";
import doubtSolverIcon from "./figma/doubt-solver-tool.svg";
import doubtSolverFeatured from "./figma/doubt-solver-featured.svg";
import slideDeckIcon from "./figma/slide-deck-tool.svg";
import assignProjectBuilder from "./figma/assign-project-builder.svg";
import assignActivityGenerator from "./figma/assign-activity-generator.svg";
import assignRealWorld from "./figma/assign-real-world.svg";
import tool1 from "./figma/tool-1.svg";
import tool2 from "./figma/tool-2.svg";
import tool3 from "./figma/tool-3.svg";
import teach1 from "./figma/teach-1.svg";
import teach2 from "./figma/teach-2.svg";
import teach3 from "./figma/teach-3.svg";
import buildDifficulty from "./figma/build-difficulty.svg";
import buildPrimary from "./figma/build-primary.svg";
import buildSection from "./figma/build-section.svg";
import filterCurriculum from "./figma/filter-curriculum.svg";
import filterGrade from "./figma/filter-grade.svg";
import filterSubject from "./figma/filter-subject.svg";
import presentIcon from "./figma/present-icon.svg";
import createQuickSheets from "./figma/create-quick-sheets.svg";
import createConceptQuestions from "./figma/create-concept-questions.svg";
import createQuestionVariations from "./figma/create-question-variations.svg";
import createQuickAssessment from "./figma/create-quick-assessment.svg";

export const images = {
  avatar,
  tutorcloudLogoMark,
  temaLogo,
  slideDeckBrandLogo,
  heroMain,
  heroDashboardIllustration,
  heroImage,
  teachThisTopicImage,
  unlockLocksmith,
  book,
  paperShelf,
  doubtSolverFeatured,
  yourTools: [tool1, tool2, tool3],
  teach: [teach1, teach2, teach3],
  build: {
    primary: buildPrimary,
    section: buildSection,
    difficulty: buildDifficulty
  },
  assign: [assignProjectBuilder, assignActivityGenerator, assignRealWorld],
  compact: [tool2, tool3, doubtSolverIcon, slideDeckIcon],
  createQuestions: {
    cardIcons: [
      createQuickSheets,
      createConceptQuestions,
      createQuestionVariations,
      createQuickAssessment,
    ],
  },
  presentIcon,
  quickSheets: {
    filterCurriculum,
    filterGrade,
    filterSubject,
  }
};
